import { render, staticRenderFns } from "./OtherPurchaseDialog.vue?vue&type=template&id=1cfce370&"
import script from "./OtherPurchaseDialog.vue?vue&type=script&lang=js&"
export * from "./OtherPurchaseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports